import React, { Component } from 'react'
import { observer } from 'mobx-react'
import FormStore from './FormStore'
import { FormProvider } from './FormContext'

@observer
class Form extends Component {
    constructor(props) {
        super(props)
        this.formStore = new FormStore()
    }

    render() {
        const { children } = this.props
        return (
            <FormProvider value={this.formStore}>
                <form>
                    {children}
                </form>
            </FormProvider>
        )
    }
}

export default Form
